module.exports = __webpack_public_path__ + "img/ede874c.jpg";